export default "__VITE_ASSET__CKDoejO6__"